import { render, staticRenderFns } from "./PropertyDetailsModal.vue?vue&type=template&id=65e8ab13"
import script from "./PropertyDetailsModal.vue?vue&type=script&lang=js"
export * from "./PropertyDetailsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports